(() => {
  'use strict';
  const input = document.getElementById('school-search');
  const finder = input?.closest('.filter-wrapper');
  if (!finder) return;
  const header = document.getElementById('SiteHeader');
  const headerWrap = document.getElementById('HeaderWrapper');
  const isFinderHash = () => ['#school-search', '#school-finder'].includes(location.hash);
  let active = false;
  let pending = false;
  let focusPending = false;
  finder.id = 'school-finder';
  finder.tabIndex = -1;
  function clearance() {
    if (!header || header.dataset.sticky !== 'true') return 16;
    const top = headerWrap ? parseFloat(getComputedStyle(headerWrap).top) || 0 : 0;
    return Math.ceil(header.getBoundingClientRect().height + Math.max(0, top) + 24);
  }
  function align() {
    pending = false;
    if (!active || !isFinderHash()) return;
    const gap = clearance();
    finder.style.scrollMarginTop = gap + 'px';
    input.style.scrollMarginTop = gap + 'px';
    const top = finder.getBoundingClientRect().top;
    if (Math.abs(top - gap) > 2) {
      window.scrollTo({top: Math.max(0, window.scrollY + top - gap), behavior: 'instant'});
    }
    if (focusPending) {
      focusPending = false;
      finder.focus({preventScroll: true});
    }
  }
  function schedule() {
    if (!active || pending) return;
    pending = true;
    requestAnimationFrame(() => requestAnimationFrame(align));
  }
  function begin() {
    active = isFinderHash();
    focusPending = active;
    schedule();
  }
  function release() {
    active = false;
    focusPending = false;
  }
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(event => {
    window.addEventListener(event, release, {capture: true, passive: true});
  });
  window.addEventListener('hashchange', begin);
  window.addEventListener('pageshow', event => {
    if (event.persisted) begin();
    else schedule();
  });
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  document.fonts?.ready.then(schedule);
  const preceding = new Set();
  for (let node = finder; node && node !== document.body; node = node.parentElement) {
    for (let previous = node.previousElementSibling; previous; previous = previous.previousElementSibling) {
      preceding.add(previous);
    }
  }
  if (window.ResizeObserver) {
    const observer = new ResizeObserver(schedule);
    preceding.forEach(element => observer.observe(element));
    if (header) observer.observe(header);
    if (headerWrap) observer.observe(headerWrap);
  }
  preceding.forEach(element => {
    element.querySelectorAll('img').forEach(image => {
      image.addEventListener('load', schedule, {once: true});
      image.addEventListener('error', schedule, {once: true});
    });
  });
  begin();
})();
